import yup, { enumValidator, arrayValidator } from '~/utils/validators.yup';
import { REVEALED_PHASE_OPTIONS } from '~/config/constants';

export const conditionSuccessFailureDetailRule = {
    conditionSuccessFailureDetail: yup.object().shape({
        condition1SuccessEffects: arrayValidator,
        condition1FailureEffects: arrayValidator,
        condition2SuccessEffects: arrayValidator,
        condition2FailureEffects: arrayValidator,
        condition3SuccessEffects: arrayValidator,
        condition3FailureEffects: arrayValidator,
        conditionRevealedPhaseOption: enumValidator(REVEALED_PHASE_OPTIONS),
    }),
};
